import React from 'react';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

import { formatMasterBrandLabel, MasterBrandLike } from '../../lib/masterBrandDisplay';

export const renderMasterBrandOption = (
  option: MasterBrandLike,
  inputValue: string,
): React.ReactNode => {
  const label = formatMasterBrandLabel(option);
  const matches = match(label, inputValue);
  const parts = parse(label, matches);

  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
          {part.text}
        </span>
      ))}
    </div>
  );
};
